import { CoordinateApiModel } from './coordinate.model';
import { LibraryApiModel } from './library.model';

export type SymbolApiModel = { id: number; name: string; library: LibraryApiModel };

export type WithCoordinates = SymbolApiModel & { coordinates: CoordinateApiModel[] };

export enum SymbolRelationship {
  COORDINATES = 'COORDINATES',
}
